<div>
  <h1 class="material-search-header" anessaTranslation="PROJECT.FEEDSTOCK.TYPE.MAT_SEARCH"></h1>
  <div *ngIf="searchData && dataLoaded">
    <!--search criteria input-->
    <mat-form-field>
      <label for="search-criteria-input" anessaTranslation="PROJECT.FEEDSTOCK.TYPE.SEARCH"></label>
      <input
        id="feedstock-dropdowns-search-criteria_input"
        matInput
        type="text"
        [(ngModel)]="searchCriteria"
        (ngModelChange)="onSearchChange()"
        name="search-criteria-input"
        id="search-criteria-input"
      >
    </mat-form-field>
    <!--list of selectable material items-->
    <div class="item-list-container border-outline">
      <ng-scrollbar style="height: 100%; display: block; overflow: scroll; max-height: 30vh;">
        <ng-container *ngIf="filteredSearchData.length < 1">
          <p anessaTranslation="PROJECT.FEEDSTOCK.TYPE.NO_RES"></p>
        </ng-container>
        <ng-container *ngFor="let item of filteredSearchData">
          <p class="list-item"
             (click)="onItemClick(item)"
          >
            {{ item.fullDisplayName | anessaTranslation: trigger}}
          </p>
        </ng-container>
      </ng-scrollbar>
    </div>
    <!--close button-->
    <div class="center close-button">
      <button
        id="feedstock-dropdowns-search-close_button"
        class="btn-red btn-compact"
        mat-button
        type="button"
        (click)="onCloseClick()"
        anessaTranslation="PROJECT.COMMON.CLOSE"
      ></button>
    </div>
  </div>
</div>
